import { render, staticRenderFns } from "./AddNewHabilitation.vue?vue&type=template&id=2d139d5f"
import script from "./AddNewHabilitation.vue?vue&type=script&lang=js"
export * from "./AddNewHabilitation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports